/** @jsxImportSource @emotion/react */
import { Message, useTheme } from "basis";
import { FC } from "react";
import { useLocation } from "react-router-dom";
import { MaxWidthContainer } from "../MaxWidthContainer/MaxWidthContainer";

// Show banner only on these pages
const BANNER_PATHNAMES = ["/", "/login"];

export const NewsBanner: FC<{}> = () => {
  const theme = useTheme();
  const { pathname } = useLocation();

  if (!BANNER_PATHNAMES.includes(pathname)) {
    return null;
  }

  return (
    <div
      css={{
        backgroundColor: theme.colors.highlight.pink.t100,
        padding: `${theme.space[4]} ${theme.space[4]}`,
        [theme.minMediaQueries.xs]: {
          padding: `${theme.space[4]} ${theme.space[10]}`,
        },
      }}
    >
      <MaxWidthContainer>
        <Message severity="info-or-minor" bg="highlight.pink.t100" padding="0">
          Welcome to the new Latitude Service Center, we hope you like the
          improvements!
        </Message>
      </MaxWidthContainer>
    </div>
  );
};
